module.exports = __webpack_public_path__ + "img/penalara.6a3cbafc.jpg";